import { render, staticRenderFns } from "./FormEmail.vue?vue&type=template&id=4a00c67c&scoped=true&"
import script from "./FormEmail.vue?vue&type=script&lang=js&"
export * from "./FormEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00c67c",
  null
  
)

export default component.exports